/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Jun 20 2023
 **/

import { z } from "zod";

export function useForm<TValues>(
	schema: z.Schema<TValues>,
	onSubmit: (values: TValues) => void,
	onError?: (error: z.ZodError<TValues>) => void
) {
	return {
		onSubmit: (values: unknown) => {
			try {
				const newValues = schema.parse(values);
				onSubmit(newValues);
			} catch (error: unknown) {
				onError && onError(error as z.ZodError);
			}
		}
	};
}

/**
 * https://github.com/colinhacks/zod/issues/372
 */
export const schemaForType =
	<T>() =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	<S extends z.ZodType<T, any, any>>(arg: S) => {
		return arg;
	};
